// camera.js
import { useRef, useState } from 'react';


let videoStream;

export const useCamera = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const constraints = { video: true };
  const apiKey = "K88923691488957";

  const startCamera = (videoElement, constraints) => {
    return navigator.mediaDevices.getUserMedia(constraints)
      .then((stream) => {
        videoStream = stream;
        videoElement.srcObject = stream;
        return stream;
      })
      .catch((error) => {
        console.error('Error accessing the camera:', error);
      });
  };

  const stopCamera = (videoElement) => {
    if (videoStream) {
      videoStream.getTracks().forEach(track => {
        track.stop();
      });
      videoElement.srcObject = null;
      videoStream = null;
    }
  };
  const processText = (text) => {
    // Find the index of 'ingredients'
    const startIndex = text.toLowerCase().indexOf('ingredients');
    
    if (startIndex !== -1) {
      // Find the index of the first period after 'ingredients'
      const endIndex = text.indexOf('.', startIndex);
      
      // Extract the substring between 'ingredients' and the first period
      const filteredText = text.substring(startIndex, endIndex !== -1 ? endIndex + 1 : undefined);
      const seperated = filteredText.trim().replace(/(\r\n|\n|\r|Ingredients:)/gm, "").split(','); // Remove new lines
       
      console.log(seperated);
      return seperated;
    } else {
      // console.error('Error: Text does not contain ingredients.');
      alert("Text does not contain ingredients, reload a new photo please");
      return '';
    }
  };
  const recognizeText = async (imageBlob) => {
    const { createWorker } = require('tesseract.js');
  
    const worker = await createWorker('eng', 1, {
        logger: m => console.log(m), // Add logger here
      });
  
    
        try {
            const { data: { text } } = await worker.recognize(imageBlob);
            //console.log('Recognized text:', text);
            const processedText = processText(text); // Process the text
            await worker.terminate();
            console.log("processedText", processedText);
            return processedText;
          } catch (error) {
            console.error('Error recognizing text:', error);
            throw error;
          }

    };


  const captureImage = async (videoElement, canvasElement) => {
    // Capture image from the video stream and draw it on the canvas
    const context = canvasElement.getContext('2d');
    canvasElement.width = videoElement.videoWidth;
    canvasElement.height = videoElement.videoHeight;
    context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);
    canvasElement.style.display = 'blocks';
  
    // Convert canvas image to a blob
    return new Promise((resolve, reject) => {
      canvasElement.toBlob(async (imageBlob) => {
        if (imageBlob) {
          try {
            // Recognize text from the image blob
            const text = await recognizeText(imageBlob);
            //sconsole.log(text);
            resolve(text);
          } catch (error) {
            reject(error);
          }
        } else {
          reject(new Error('No image data'));
        }
      }, 'image/png');
    });
  };
  
  
  const clearCanvas = (canvasElement) => {
    const context = canvasElement.getContext('2d');
    context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  };

  const handleToggleCamera = () => {
    if (!stream) {
      startCamera(videoRef.current, constraints).then((stream) => {
        setStream(stream);
      });
    } else {
      stopCamera(videoRef.current);
      setStream(null);
    }
  };

  const handleCapture = () => {
    captureImage(videoRef.current, canvasRef.current, apiKey);
  };

  const handleClear = () => {
    clearCanvas(canvasRef.current);
  };

  return {
    videoRef,
    canvasRef,
    handleToggleCamera,
    handleCapture,
    handleClear,
    recognizeText
  };
};
